import React from 'react'
import Avatar from '@material-ui/core/Avatar';
import './EditProfile.css'
import EditIcon from '@material-ui/icons/Edit';


function EditProfile() {
    return (
        <div className="CollectionAsset EditProfile">
            <form className="contactForm" action="">
            <h2 className="formSectioTitle">Edit profile</h2>
                <div className="formContorll editProfileImages">
                    <div className="profileAppImagesPrewview">
                    <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg"/>
                    </div>
                    <input className="profileAppImagesPrewviewInput" type="file" placeholder="username" accept="image/JPG, image/PNG, image/GIF, image/WEBP, image/TIFF, image/PSD, image/RAW, image/BMP, image/HEIF, image/INDD, image/JPEG," />
                </div>
                <div className="formContorll">
                    <label htmlFor="">Display name</label>
                    <input type="text" placeholder="username" />
                </div>
                <div className="formContorll">
                    <label htmlFor="">Bio</label>
                    <input type="text" placeholder="Bio" />
                </div>
                <div className="formContorll">
                    <label htmlFor="">Personal site</label>
                    <input type="url" placeholder="https://" />
                </div>
                <br />
                <br />
                <h4>Social Media</h4>
                <div className="formContorll">
                    <label htmlFor="">Twitter</label>
                    <input type="url" placeholder="https://" />
                </div>
                <div className="formContorll">
                    <label htmlFor="">Reddit</label>
                    <input type="url" placeholder="https://" />
                </div>
                <div className="formContorll">
                    <label htmlFor="">Instagram</label>
                    <input type="url" placeholder="https://" />
                </div>
                <div className="formContorll">
                    <label htmlFor="">Youtube</label>
                    <input type="url" placeholder="https://" />
                </div>
                <button className="AssetsActionBtn btnCreateNew">Update Profile</button>
            </form>
        </div>
    )
}

export default EditProfile
